import NotFoundRoute from './not-found.route';

const route = {
  path: '*',
  redirect: { name: NotFoundRoute.name },
};

export default route;
